/* import __COLOCATED_TEMPLATE__ from './container.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { AutoAnimateModifierOptions } from 'volta/modifiers/autoanimate';

export interface BvDndContainerSignature {
  Args: {
    animate?: boolean;
    animateOptions?: AutoAnimateModifierOptions;
    items?: any[];
    name?: string;
    onDestroy: (element: HTMLElement, [items]: [object[]]) => void;
    onInsert: (element: HTMLElement, [items]: [object[]]) => void;
    onUpdate: (element: HTMLElement, [items]: [object[]]) => void;
    tag?: string;
  };
  Blocks: {
    default: [BvDndContainerSignature['Args']['items']];
  };
  Element: HTMLElement;
}

const BvDndContainerComponent = templateOnlyComponent<BvDndContainerSignature>('BvDnd::Container');

export default BvDndContainerComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvDnd::Container': typeof BvDndContainerComponent;
    'bv-dnd/container': typeof BvDndContainerComponent;
  }
}
